export interface IStructureModel {
    id: number;
    structureTypeId: number;
    jobId?: number;
    customerId: number;
    description: string;
    volume: number;
    height: number;
    width: number;
    depth: number;
}


export class StructureModel implements IStructureModel {
    id: number = 0;
    structureTypeId: number = 0;
    jobId?: number;
    customerId: number = 0;
    description: string = '';
    volume: number = 0;
    height: number = 0;
    width: number = 0;
    depth: number = 0;

    constructor(init?: Partial<StructureModel>) {
        Object.assign(this, init);
    }
}
